module.exports = __webpack_public_path__ + "static/media/doc.5d8c48a8.svg";